export function filterCategory() {
    const procedureContainer = document.querySelector('.procedures__container');

    procedureContainer.onscroll = () => {
        const distanceProcedureContainerFromTop =
            procedureContainer.getBoundingClientRect().top;

        const elements = document.querySelectorAll(
            '.procedure-section__container'
        );

        for (const i of elements) {
            const distance = i.getBoundingClientRect().top;

            if (
                distance < distanceProcedureContainerFromTop + 20 &&
                distance > distanceProcedureContainerFromTop - 20
            ) {
                const allDivCategories =
                    document.querySelectorAll('.category__option');
                const id = i.getAttribute('id');
                for (const j of allDivCategories) {
                    j.classList.remove('category__option--selected');
                    if (j.getAttribute('data-id') === id) {
                        j.classList.add('category__option--selected');
                        j.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'nearest',
                        });
                    }
                }
            }
        }
    };
}
